module.exports = __webpack_public_path__ + "img/Docker.7bcbbab5.png";